import React, { useContext } from 'react'
import { ProjectContext } from '../../../context/ProjectContext'
import { StarsFilter } from './filters/stars'
import { MeetingsFilter } from './filters/meetings'
import { SortFilter } from './filters/sortFilter'
import ProblemsList from '../problems/problems'

export function Problems() {
  const {
    filteredProblems,
    problemsFilters,
    setProblemsFilters,
    isLoading,
    setProblems,
    meetings,
    participants,
    setProject,
    project,
  } = useContext(ProjectContext)

  return (
    <div className="w-full bg-white rounded-xl p-8 shadow-sm border border-[#e4e4e4]">
      <div className="pb-8 border-b border-[#e4e4e4]">
        <p className="text-[#3f424a] text-4xl font-bold font-['DM_Sans'] leading-[41.40px]">Pain Points</p>
      </div>

      <div
        className="w-full h-12 mt-[20px] mb-[6px] bg-white rounded-[10px] flex items-center"
        style={{ boxShadow: '0px 0px 16px 8px rgba(0, 0, 0, 0.15)' }}
      >
        <StarsFilter filters={problemsFilters} setFilters={setProblemsFilters} label={'Pain Points'} />
        <MeetingsFilter filters={problemsFilters} setFilters={setProblemsFilters} />
        <SortFilter filters={problemsFilters} setFilters={setProblemsFilters} />
      </div>

      {isLoading ? (
        <div className="flex justify-center items-center h-[calc(100%-40px)]">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#FF4A8E]"></div>
        </div>
      ) : (
        <div className="w-full flex flex-wrap relative">
          <ProblemsList
            problems={filteredProblems}
            setProblems={setProblems}
            meetings={meetings}
            participants={participants}
            setProject={setProject}
            project={project}
          />
        </div>
      )}
    </div>
  )
}
